export default __webpack_public_path__ + "static/media/g_brhlik_lesni-min.cb50b17b.jpg";